import { styled } from '@linaria/react';

import { Color } from './ColorfulParticlesDemo.types';

export function formatForCss(color: Color) {
  if (color.type === 'rgb') {
    return `rgb(${color.values.r} ${color.values.g} ${color.values.b})`;
  } else if (color.type === 'hsl') {
    return `hsl(${color.values.h}deg ${color.values.s}% ${color.values.l}%)`;
  } else if (color.type === 'oklch') {
    return `oklch(${color.values.l} ${color.values.c} ${color.values.h})`;
  }

  return '';
}

export function checkIfTwoColorsAreIdentical(
  fromColor: Color,
  toColor: Color
) {
  switch (fromColor.type) {
    case 'rgb': {
      if (toColor.type !== 'rgb') {
        throw new Error(
          `Expected “to” color to be of type “rgb”, but got “${toColor.type}”`
        );
      }
      return (
        fromColor.values.r === toColor.values.r &&
        fromColor.values.g === toColor.values.g &&
        fromColor.values.b === toColor.values.b
      );
    }
    case 'hsl': {
      if (toColor.type !== 'hsl') {
        throw new Error(
          `Expected “to” color to be of type “hsl”, but got “${toColor.type}”`
        );
      }
      return (
        fromColor.values.h === toColor.values.h &&
        fromColor.values.s === toColor.values.s &&
        fromColor.values.l === toColor.values.l
      );
    }
    case 'oklch': {
      if (toColor.type !== 'oklch') {
        throw new Error(
          `Expected “to” color to be of type “oklch”, but got “${toColor.type}”`
        );
      }
      return (
        fromColor.values.l === toColor.values.l &&
        fromColor.values.c === toColor.values.c &&
        fromColor.values.h === toColor.values.h
      );
    }
  }
}

export function formatWithSyntaxHighlighting(color: Color) {
  if (color.type === 'rgb') {
    return (
      <>
        rgb(
        <Value>{color.values.r}</Value>{' '}
        <Value>{color.values.g}</Value>{' '}
        <Value>{color.values.b}</Value>)
      </>
    );
  } else if (color.type === 'hsl') {
    return (
      <>
        hsl(
        <Value>{color.values.h}deg</Value>{' '}
        <Value>{color.values.s}%</Value>{' '}
        <Value>{color.values.l}%</Value>)
      </>
    );
  } else if (color.type === 'oklch') {
    return (
      <>
        oklch(<Value>{color.values.l}</Value>{' '}
        <Value>{color.values.c}</Value>{' '}
        <Value>{color.values.h}</Value>)
      </>
    );
  }
}

const Value = styled.span`
  color: white;
  font-weight: var(--font-weight-medium);
  white-space: pre;
`;
